<script>
    import { onMount } from "svelte";

    // Estados para os valores dos sliders
    export let carboidrato = 33;
    export let proteina = 33;
    export let lipideo = 34;
    export let nee = 2000;
    export let nee2 = 2500;
    export let nee3 = 2500;
    // Estados adicionais
    let selectedNee = nee;
    let caloricAdjustmentType = "superavit";
    let caloricAdjustmentValue = 0;
    let adjustedNee = selectedNee;
    // Valores calculados
    let carboidratoG = 0;
    let carboidratoKcal = 0;
    let proteinaG = 0;
    let proteinaKcal = 0;
    let lipideoG = 0;
    let lipideoKcal = 0;
    let totaisG = 0;
    let totaisKcal = 0;
    let totalPercentual = 0;
    let alertMessage = "";

    // Função para atualizar valores
    function calcularValores() {
        adjustedNee = selectedNee;
        if (caloricAdjustmentType === "superavit") {
            adjustedNee += parseFloat(caloricAdjustmentValue);
        } else {
            adjustedNee -= parseFloat(caloricAdjustmentValue);
        }
        let pNee = parseFloat(adjustedNee) / 100;

        totalPercentual = carboidrato + proteina + lipideo;

        carboidratoKcal = parseFloat((carboidrato * pNee).toFixed(2));
        carboidratoG = parseFloat((carboidratoKcal / 4).toFixed(2));

        proteinaKcal = parseFloat((proteina * pNee).toFixed(2));
        proteinaG = parseFloat((proteinaKcal / 4).toFixed(2));

        lipideoKcal = parseFloat((lipideo * pNee).toFixed(2));
        lipideoG = parseFloat((lipideoKcal / 9).toFixed(2));

        // Agora soma os valores numéricos
        totaisG = carboidratoG + proteinaG + lipideoG;
        totaisKcal = carboidratoKcal + proteinaKcal + lipideoKcal;

        // Formatação final para exibição
        totaisG = totaisG.toFixed(2);
        totaisKcal = totaisKcal.toFixed(2);

        // Verificar se passa de 100%
        if (totalPercentual > 100) {
            alertMessage =
                totalPercentual + " A soma dos percentuais ultrapassa 100%!";
        } else {
            alertMessage = "";
        }
    }

    // Atualiza os valores quando o componente é montado
    onMount(calcularValores);
</script>

<div class="container mt-4">
    <div class="row mb-3">
        <div class="col">
            <h4>Selecione o NEE</h4>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    name="nee"
                    checked={selectedNee === nee}
                    on:change={() => {
                        selectedNee = nee;
                        calcularValores();
                    }}
                />
                <label class="form-check-label">
                    NEE 1 (Atual): {nee.toFixed(2)} kcal
                </label>
            </div>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    name="nee"
                    checked={selectedNee === nee2}
                    on:change={() => {
                        selectedNee = nee2;
                        calcularValores();
                    }}
                />
                <label class="form-check-label">
                    NEE 2(MIFFLIN): {nee2.toFixed(2)} kcal
                </label>
            </div>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    name="nee"
                    checked={selectedNee === nee2}
                    on:change={() => {
                        selectedNee = nee3;
                        calcularValores();
                    }}
                />
                <label class="form-check-label">
                    NEE 3 (HARRIS-BENEDICT): {nee3.toFixed(2)} kcal
                </label>
            </div>
        </div>

        
    </div>

    <div class="row mb-3">
        <div class="col">
            <h4>Ajuste Calórico</h4>
            <div class="mb-3">
                <label for="caloricAdjustmentType" class="form-label"
                    >Tipo de Ajuste:</label
                >
                <select
                    id="caloricAdjustmentType"
                    class="form-select"
                    bind:value={caloricAdjustmentType}
                    on:change={calcularValores}
                >
                    <option value="superavit">Superavit</option>
                    <option value="deficit">Deficit</option>
                </select>
            </div>
            <div class="mb-3">
                <label for="caloricAdjustmentValue" class="form-label"
                    >Valor do Ajuste (kcal):</label
                >
                <input
                    type="number"
                    id="caloricAdjustmentValue"
                    class="form-control"
                    bind:value={caloricAdjustmentValue}
                    on:input={calcularValores}
                />
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col">
            <h4>Distribuição de Macronutrientes</h4>
            <div class="mb-3">
                <label for="carboidrato" class="form-label"
                    >Carboidrato: {carboidrato}%</label
                >
                <input
                    type="range"
                    id="carboidrato"
                    class="form-range"
                    min="0"
                    max="100"
                    bind:value={carboidrato}
                    on:input={calcularValores}
                />
            </div>
            <div class="mb-3">
                <label for="proteina" class="form-label"
                    >Proteína: {proteina}%</label
                >
                <input
                    type="range"
                    id="proteina"
                    class="form-range"
                    min="0"
                    max="100"
                    bind:value={proteina}
                    on:input={calcularValores}
                />
            </div>
            <div class="mb-3">
                <label for="lipideo" class="form-label"
                    >Lipídio: {lipideo}%</label
                >
                <input
                    type="range"
                    id="lipideo"
                    class="form-range"
                    min="0"
                    max="100"
                    bind:value={lipideo}
                    on:input={calcularValores}
                />
            </div>
        </div>
    </div>

    {#if alertMessage}
        <div class="alert alert-danger">{alertMessage}</div>
    {/if}

    <div class="row mb-3">
        <div class="col">
            <h4>Resultados</h4>
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Nutriente</th>
                        <th>Percentual (%)</th>
                        <th>Gramas (g)</th>
                        <th>Calorias (kcal)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Carboidrato</td>
                        <td>{carboidrato}%</td>
                        <td>{carboidratoG}</td>
                        <td>{carboidratoKcal}</td>
                    </tr>
                    <tr>
                        <td>Proteína</td>
                        <td>{proteina}%</td>
                        <td>{proteinaG}</td>
                        <td>{proteinaKcal}</td>
                    </tr>
                    <tr>
                        <td>Lipídio</td>
                        <td>{lipideo}%</td>
                        <td>{lipideoG}</td>
                        <td>{lipideoKcal}</td>
                    </tr>
                    <tr>
                        <td>Totais</td>
                        <td>{totalPercentual}%</td>
                        <td>{totaisG}</td>
                        <td>{totaisKcal}</td>
                    </tr>
                    <tr>
                        <td>NEE Ajustado</td>
                        <td colspan="3">{adjustedNee.toFixed(2)} kcal</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<style>
    .container {
        padding: 20px;
        font-family: Arial, sans-serif;
    }

    .slider-container,
    .radio-container,
    .select-container,
    .input-container {
        margin-bottom: 20px;
    }

    .alert {
        color: red;
        font-weight: bold;
    }

    .values {
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
    }

    .value-box {
        text-align: center;
    }
</style>
